module.exports = __webpack_public_path__ + "static/abo-141b217567b9d3abe9ddf6fcfb821fc7.png";